import React from "react";
import { Icon } from "@elaniintc/goes-design-system";

interface InfoMessageProps {
  children: React.ReactNode;
  className?: string;
  iconType?: string;
  iconName?: string;
}

const InfoMessage: React.FC<InfoMessageProps> = ({
  children,
  className = "",
  iconType = "far",
  iconName = "info-circle",
}) => (
  <div
    className={`flex items-center gap-2 text-xs font-normal text-info ${className}`}
  >
    <Icon type={iconType} name={iconName} />
    <span>{children}</span>
  </div>
);

export default InfoMessage;
